module.exports = __webpack_public_path__ + "assets/icons/analytics-logo.7ea2774e0e4026665e6b0aa8005c8b6e.svg";